import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=ef733a8a&scoped=true&"
import script from "./Promotion.vue?vue&type=script&lang=ts&"
export * from "./Promotion.vue?vue&type=script&lang=ts&"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=ef733a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef733a8a",
  null
  
)

export default component.exports